import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useLocations } from "@/hooks/useMeta";

const ALL = "__all";

/** Province + district selector backed by the Turkey location dataset. */
export default function LocationSelect({ province, district, onChange, allowAll = false, prefix = "location" }) {
  const { data: locs = [] } = useLocations();
  const districts = locs.find((l) => l.name === province)?.districts || [];
  return (
    <div className="grid grid-cols-2 gap-2">
      <Select value={province || (allowAll ? ALL : undefined)} onValueChange={(v) => onChange(v === ALL ? "" : v, "")}>
        <SelectTrigger data-testid={`${prefix}-province-select`} aria-label="İl seçimi"><SelectValue placeholder="İl seçin" /></SelectTrigger>
        <SelectContent className="max-h-72">
          {allowAll && <SelectItem value={ALL}>Tüm Türkiye</SelectItem>}
          {locs.map((l) => <SelectItem key={l.code} value={l.name}>{l.name}</SelectItem>)}
        </SelectContent>
      </Select>
      <Select disabled={!province} value={district || (allowAll ? ALL : undefined)} onValueChange={(v) => onChange(province, v === ALL ? "" : v)}>
        <SelectTrigger data-testid={`${prefix}-district-select`} aria-label="İlçe seçimi"><SelectValue placeholder="İlçe seçin" /></SelectTrigger>
        <SelectContent className="max-h-72">
          {allowAll && <SelectItem value={ALL}>Tüm ilçeler</SelectItem>}
          {districts.map((d) => <SelectItem key={d} value={d}>{d}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}
